/**
 * File file-download.js.
 *
 * Custom code to kickstart AJAX functions for file download.
 *
 */

( function( $ ) {
    var ajaxurl = window.location.origin + '/wp-admin/admin-ajax.php';
    $('.download__pdf').on('change', function() {
       
        var attachment_id = $(this).val();
        $.ajax({
            type: 'POST',
            url: ajaxurl,
            dataType: 'html',
            data: {
                action: 'file_download',
                attachment_id: attachment_id,
            },
            success: function(response) {
                var pdf_info = JSON.parse(response);
                $('.btn--download').attr('href', pdf_info.pdf_file);
            }
        });
    });


} )( window.jQuery );
